import Vue from 'vue'
import Vuex from 'vuex'

import userStore from './modules/userStore'
import multTabStore from './modules/multTabStore'
import enumsStore from './modules/enumsStore'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    userStore,
    multTabStore,
    enumsStore
  }
})
